export default __webpack_public_path__ + "static/media/fuzhilianjie.91d8b811.png";